import * as actionTypes from "../../actions/actionTypes";
import initialState from "../initialState";

export default function employeeListReducer(state = initialState.employee, action) {
  switch (action.type) {
    case actionTypes.EMPLOYEE_LIST_SUCCESS:
      return action.payload;
      case actionTypes.EMPLOYEE_LIST_ERROR:
        return action.payload;
    default:
      return state;
  }
}